import { irwin, featureFlags, env } from './'

export const FEATURE_FLAG_CONFIG = {
  url: `${featureFlags?.baseUrl || irwin.baseUrl}/admin/feature/flags/proxy`,
  clientKey: import.meta.env.VITE_FEATURE_FLAGS_KEY,
  refreshInterval: 600,
  appName: 'admin-fe',
  environment: env,
}
